import * as yup from 'yup';

const validationSchema = (intl) =>
  yup.object().shape({
    email: yup
      .string('')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        intl.formatMessage({ id: 'validation.email' })
      )
      .required(intl.formatMessage({ id: 'validation.required' })),
    password: yup.string('').required(intl.formatMessage({ id: 'validation.required' })),
  });

export default validationSchema;
